import { render } from "./home.vue?vue&type=template&id=3b7bb603"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"

import "./home.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__